<script setup lang="ts">
/**
 * Toggle switch visual (track + thumb). The interactive wrapper (button + label + click) stays in
 * the consumer; this just renders the on/off pill, driven by `modelValue`. Consolidates the
 * sync-to-map switch re-implemented in WorkspaceToolbar / WorkspaceMobileToolbar.
 */
interface Props {
  modelValue?: boolean
}
const props = withDefaults(defineProps<Props>(), { modelValue: false })
</script>

<template>
  <span
    aria-hidden="true"
    class="relative inline-flex h-4 w-7 shrink-0 rounded-full transition-colors duration-200"
    :class="props.modelValue ? 'bg-primary-500' : 'bg-gray-300'"
  >
    <span
      class="absolute left-0.5 top-0.5 h-3 w-3 rounded-full bg-white shadow transition-transform duration-200"
      :class="props.modelValue ? 'translate-x-3' : 'translate-x-0'"
    />
  </span>
</template>
